import { useEffect } from 'react'

export default function Redirect() {
  useEffect(() => {
    window.location.href = 'https://aiornot.hackfree.com'
  })
  return null
}
